import { render, staticRenderFns } from "./QuoteProposalSummaryDetailCard.vue?vue&type=template&id=37d8fa04&"
import script from "./QuoteProposalSummaryDetailCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteProposalSummaryDetailCard.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteProposalSummaryDetailCard.vue?vue&type=style&index=0&id=37d8fa04&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports